import { idtype } from "querypieces";

export default `
...on pageBuilder_outcomesMatrix_BlockType {
	${idtype}
	heading
	outcomesMatrix {
		... on outcomeBlock_Entry {
		  id
		  altText
		  subheader
		  bodyCopy
		  image {
			id
			extension
			title
			url
			img
		  }
		}
	  }
}
`